<template>
    <div>
        <!-- 页面标题 - 内容由父组件传入 -->
        <div class="page-title">
            <h1>{{ title }}</h1>
            <p>{{ subtitle }}</p>
        </div>
    </div>
</template>

<script>
export default {
    // 定义接收父组件传入的属性
    props: {
        // 主标题
        title: {
            type: String,
            required: true, // 要求父组件必须传入
            default: '页面标题' // 默认值，防止未传入时显示异常
        },
        // 副标题
        subtitle: {
            type: String,
            required: false,
            default: '' // 副标题可选
        }
    }
}
</script>
<style scoped>
.page-title {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e8e8e8;
}
</style>